import React from 'react';
import LinkButton from '|/components/carvana-ds/link-button';
import VehicleImage from '|/components/vehicle-image';
import styles from './slate-vehicle-card.module.css';
import type { VehicleCardProps } from '../vehicle-card/types';
import {
  financeTotalLabel,
  formatCurrency,
  getNonFinanceLabel
} from '../vehicle-card/vehicle-card-helpers';

const SlateVehicleCard: React.FC<VehicleCardProps> = ({ summary, onViewOrderDetails }) => {
  const { stockNumber, year, make, model, purchaseType, monthlyPayment, cashDue } = summary;

  const isFinance = purchaseType === 'finance';
  const totalDisplay = isFinance ? financeTotalLabel(cashDue ?? 0) : getNonFinanceLabel(summary);

  return (
    <div className={styles.card} data-testid="pp_checkout_slate-vehicle-card">
      <div className={styles.content}>
        <div className={styles.mediaWrap}>
          <VehicleImage
            stockNumber={stockNumber}
            width={800}
            variant="desktop"
            alt={`${year} ${make} ${model}`}
            className={styles.media}
          />
        </div>

        <p className={styles.vehicleName}>
          {year} {make} {model}
        </p>

        <div className={styles.priceDetails}>
          <div className={styles.pricing}>
            {isFinance && (
              <div className={styles.stat}>
                <span className={styles.statLabel}>Payment</span>
                <span className={styles.statAmountRow}>
                  <span className={styles.statAmount}>{formatCurrency(monthlyPayment ?? 0)}</span>
                  <span className={styles.statSuffix}>/mo</span>
                </span>
              </div>
            )}
            <div className={styles.stat}>
              <span className={styles.statLabel}>{totalDisplay.label}</span>
              <span className={styles.statAmount}>{formatCurrency(totalDisplay.amount)}</span>
            </div>
          </div>

          <LinkButton
            className={styles.priceDetailsButton}
            size="sm"
            onClick={onViewOrderDetails}
            data-analytics-id="checkout-vehicle-card-review-order"
            data-testid="pp_checkout_slate-vehicle-card_price-details"
          >
            Price details
          </LinkButton>
        </div>
      </div>
    </div>
  );
};

export default SlateVehicleCard;
